import React, { useState } from "react";

// NOTE: Client-side gate only. The password lives in the JS bundle, so this
// keeps casual visitors out but is not real security. For real protection,
// use Netlify password-protected sites (Pro plan).
const PASSWORD = "ibc_test";
const STORAGE_KEY = "ibc4eu_unlocked";

const C = {
  bg: "#E8EEF5",
  panel: "#FFFFFF",
  border: "#D6E0EC",
  accent: "#3F8FBF",
  text: "#1A2A44",
  muted: "#6B7E96",
  brandNavy: "#152A4A",
  brandOrange: "#E8902A",
  error: "#C25E5E",
};

export default function PasswordGate({ children }) {
  const [unlocked, setUnlocked] = useState(
    () => sessionStorage.getItem(STORAGE_KEY) === "true"
  );
  const [input, setInput] = useState("");
  const [error, setError] = useState(false);

  if (unlocked) return children;

  const submit = (e) => {
    e.preventDefault();
    if (input === PASSWORD) {
      sessionStorage.setItem(STORAGE_KEY, "true");
      setUnlocked(true);
    } else {
      setError(true);
    }
  };

  return (
    <div
      style={{
        fontFamily: "'DM Sans','Segoe UI',sans-serif",
        background: C.bg,
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: 24,
        color: C.text,
      }}
    >
      <form
        onSubmit={submit}
        style={{
          background: C.panel,
          border: `1px solid ${C.border}`,
          borderRadius: 12,
          padding: "32px 36px",
          width: "100%",
          maxWidth: 380,
          boxShadow: "0 4px 24px rgba(21,42,74,0.08)",
          display: "flex",
          flexDirection: "column",
          gap: 16,
        }}
      >
        <img
          src="/ibc4u-logo.png"
          alt="IBC4EU"
          style={{ height: 48, objectFit: "contain", alignSelf: "flex-start" }}
        />
        <div>
          <div style={{ fontSize: 18, fontWeight: 700, color: C.brandNavy, marginBottom: 4 }}>
            EU PV Industrial Trajectory Model
          </div>
          <div style={{ fontSize: 12, color: C.muted }}>
            This page is password-protected. Enter the access password to continue.
          </div>
        </div>
        <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
          <label htmlFor="ibc4eu-pw" style={{ fontSize: 10, fontWeight: 700, color: C.muted, letterSpacing: "1px", textTransform: "uppercase" }}>
            Password
          </label>
          <input
            id="ibc4eu-pw"
            type="password"
            autoFocus
            value={input}
            onChange={(e) => {
              setInput(e.target.value);
              if (error) setError(false);
            }}
            style={{
              background: "#F8FAFC",
              border: `1px solid ${error ? C.error : C.border}`,
              borderRadius: 6,
              padding: "10px 12px",
              fontSize: 14,
              color: C.text,
              outline: "none",
              fontFamily: "inherit",
            }}
          />
          {error && (
            <div style={{ fontSize: 11, color: C.error, marginTop: 2 }}>
              Incorrect password. Try again.
            </div>
          )}
        </div>
        <button
          type="submit"
          style={{
            background: C.brandNavy,
            color: "#FFFFFF",
            border: "none",
            borderRadius: 6,
            padding: "10px 14px",
            fontSize: 14,
            fontWeight: 600,
            cursor: "pointer",
            fontFamily: "inherit",
          }}
        >
          Enter
        </button>
        <a
          href="/"
          style={{
            fontSize: 11,
            color: C.accent,
            textDecoration: "none",
            textAlign: "center",
            marginTop: -4,
          }}
        >
          ← Back to Solar Manufacturing Tool
        </a>
      </form>
    </div>
  );
}
